import script from "./SunburstChart.vue?vue&type=script&setup=true&lang=js"
export * from "./SunburstChart.vue?vue&type=script&setup=true&lang=js"

import "./SunburstChart.vue?vue&type=style&index=0&id=74a1a376&lang=css"

const __exports__ = script;

export default __exports__